import LinkOutlinedIcon from '@mui/icons-material/LinkOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import copy from 'copy-to-clipboard';
import {
  MDBBtn,
  MDBModal,
  MDBModalBody,
  MDBModalContent,
  MDBModalDialog,
  MDBModalFooter,
  MDBModalHeader,
  MDBModalTitle,
} from 'mdb-react-ui-kit';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import ReactPaginate from 'react-paginate';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Menu, Table } from 'semantic-ui-react';
import { DataNotFound } from '../../../../../components/DataNotFound';
import LoadingAnimation from '../../../../../components/LoadingAnimation';
import SearchFilters from '../../../../../components/elements/SearchFilter';
import Userbanner from '../../../../../components/elements/Userbanner';
import { getFromLocalStorage } from '../../../../../components/helper/authorizationHelper';
import { getAsync, postAsync, reactURL } from '../../../../../components/helper/axiosHelper';
import { downloadCSV } from '../../../../../components/helper/downloadCSVHelper';
import { setCompaignList } from '../../../../../features/compaignListSlice';
import { PageHitCountApi } from '../../../../../shared/Helper';
import { useLocation } from 'react-use';
import { printTable } from '../../../../../utils/tableExportUtils';
const CampaignList = () => {
  const isActive = useSelector((state) => state.toggle.isActive);
  const compaignList = useSelector((state) => state.compaignList.list);
  const [gridModalOpen, setGridModalOpen] = useState(false);
  const [selectedReason, setSelectedReason] = useState(null);
  const [next, setNext] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [pageCount, setPageCount] = useState(1);
  const [epUserID, setEpUserID] = useState(null);
  const [dateTo, setDateTo] = useState('');
  const [dateFrom, setDateFrom] = useState('');
  const [datanotfound, setDatanotfound] = useState(false);
  // const [serviceCheck, setServiceCheck] = useState(false);

  const [serviceCheck, setServiceCheck] = useState({
    serviceShow: false,
    statusCode: 0,
    message: '',
  });

  const [pageOptions, setPageOptions] = useState({
    pageNo: 1,
    pageSize: 20,
  });


  const {pathname} = useLocation();
  const dispatch = useDispatch();
  const { t } = useTranslation();


  const isLogin = () => {
    if (localStorage.getItem('token')) return true;
    window.location.href = '/donorLogin';
  };

  const bodyGet = {
    epUserID: epUserID,
  };
  useEffect(() => {
    localStorage.setItem('isHome', false);
    const retrievedData = getFromLocalStorage('upid');
    retrievedData
      ?.then((res) => {
        setEpUserID(res);
      })
      .catch((err) => {
        console.log('data', err);
      });

    const getCampaigns = async () => {
      setIsLoading(true);
      await postAsync('Campaign/GetCampaignFilterList/' + pageOptions.pageNo + '/' + pageOptions.pageSize, bodyGet)
        .then((response) => {
          if (response.statusCode === 422) {
            setServiceCheck((prevState) => ({
              ...prevState,
              serviceShow: true,
              statusCode: 422,
              message: response.message,
            }));
          } else if (response.statusCode === 406) {
            setServiceCheck((prevState) => ({
              ...prevState,
              serviceShow: true,
              statusCode: 406,
              message: response.message,
            }));
          } else if (response.statusCode === 426) {
            setServiceCheck((prevState) => ({
              ...prevState,
              serviceShow: true,
              statusCode: 426,
              message: response.message,
            }));
          } else if (response.statusCode === 423) {
            setServiceCheck((prevState) => ({
              ...prevState,
              serviceShow: true,
              statusCode: 423,
              message: response.message,
            }));
          } else if (response.statusCode === 422) {
            setServiceCheck(true);
          }
          setIsLoading(false);
          dispatch(setCompaignList(response.data));
          setPageCount(response.page);
          if (response?.statusCode == 204) {
            setDatanotfound(true);
          }
        })
        .catch((err) => {
          console.log(err);
          toast.error(t('Something went wrong, Please try again!'));
        });
    };
    if (epUserID !== null) {
      getCampaigns();
      PageHitCountApi(pathname, epUserID);
    }
    setNext(1);
  }, [epUserID]);

  const SearchFilter = {
    epUserID: epUserID,
    dateFrom: moment(dateFrom).format('DD/MM/YYYY'),
    dateTo: moment(dateTo).format('DD/MM/YYYY'),
  };

  const getPaginationList = async () => {
    try {
      setIsLoading(true);
      setDatanotfound(false);
      const response = await postAsync(
        `Campaign/GetCampaignFilterList/${pageOptions.pageNo}/${pageOptions.pageSize}`,
        SearchFilter,
      );
      if (response) {
        setIsLoading(false);
      }
      if (response.statusCode === 422) {
        setServiceCheck((prevState) => ({
          ...prevState,
          serviceShow: true,
          statusCode: 422,
          message: response.message,
        }));
      } else if (response.statusCode === 406) {
        setServiceCheck((prevState) => ({
          ...prevState,
          serviceShow: true,
          statusCode: 406,
          message: response.message,
        }));
      } else if (response.statusCode === 426) {
        setServiceCheck((prevState) => ({
          ...prevState,
          serviceShow: true,
          statusCode: 426,
          message: response.message,
        }));
      } else if (response.statusCode === 423) {
        setServiceCheck((prevState) => ({
          ...prevState,
          serviceShow: true,
          statusCode: 423,
          message: response.message,
        }));
      } else if (response?.statusCode == 204) {
        setDatanotfound(true);
      }
      dispatch(setCompaignList(response?.data));
      setPageCount(response.page);
      setNext(pageOptions.pageNo);
    } catch (err) {
      console.log(err);
      toast.error(t('Something went wrong, Please try again!'));
    }
  };

  const handleCopy = async (e, id) => {
    e.preventDefault();

    try {
      await getAsync('Campaign/GetCampaignListById', {
        id: id,
      })
        .then((response) => {
          const result = response?.data[0];
          if (
            result?.campaignID === undefined ||
            result?.campaignID === null ||
            result?.campaignID === 0 ||
            result?.campaignLink === undefined ||
            result?.campaignLink === null ||
            result?.campaignLink === ''
          ) {
            toast.error(t('Something went wrong, Please try again!'));
          } else {
            const campaignRefferalLink = `${reactURL}/CampaignRefferral/` + result?.campaignLink + '/' + 2;
            copy(campaignRefferalLink);
            toast.success(t('Link copy Successfully'));
          }
        })
        .catch(() => {
          toast.error(t('Something went wrong, Please try again!'));
        });
    } catch (error) {
      toast.error(t('Something went wrong, Please try again!'));
    }
  };

  const handleSearch = async (e) => {
    e.preventDefault();
    await getPaginationList();
  };

  const changePage = async ({ selected }) => {
    const newPage = selected + 1;
    // setNext(selected + 1);

    try {
      if (dateFrom === '' && dateTo === '') {
        // Fetch data using the updated page number
        const response = await postAsync(`Campaign/GetCampaignFilterList/${newPage}/${pageOptions.pageSize}`, bodyGet);
        if (response.statusCode === 422) {
          setServiceCheck(true);
        }
        dispatch(setCompaignList(response.data));
        setPageCount(response.page);
        setNext(selected + 1);
      } else {
        // Fetch data using the updated page number
        const response = await postAsync(
          `Campaign/GetCampaignFilterList/${newPage}/${pageOptions.pageSize}`,
          SearchFilter,
        );
        dispatch(setCompaignList(response.data));
        setPageCount(response.page);
      }
    } catch (err) {
      console.log(err);
      toast.error(t('Something went wrong, Please try again!'));
    }
  };

  const openModal = (e, campaignID) => {
    e.preventDefault();
    const selectedReason = compaignList.find((data) => data.campaignID === campaignID)?.description;
    setSelectedReason(selectedReason);
    setGridModalOpen(true);
  };

  const closeModal = (e) => {
    e.preventDefault();
    setGridModalOpen(false);
  };
  const displayRecords = compaignList?.map((data, index) => {
    const sno = (next - 1) * pageOptions.pageSize + index + 1;
    return (
      <Table.Row key={index} items={compaignList}>
        <Table.Cell>{sno}</Table.Cell>
        <Table.Cell>{data?.campaignName || 'N/A'}</Table.Cell>
        {/* <Table.Cell>{data?.description}</Table.Cell> */}
        <Table.Cell>
          {/* Modal Create */}
          <>
            <button
              className="text-white w-20 bg-customgreen transition duration-700 ease-in-out hover:bg-hovergreen focus:outline-none font-medium rounded-full text-sm px-4 py-2 me-2 text-center"
              onClick={(e) => openModal(e, data?.campaignID)}
            >
              {t('')} <VisibilityOutlinedIcon />
            </button>
          </>
          {/* end */}
        </Table.Cell>
        <Table.Cell>{data?.date || 'N/A'}</Table.Cell>
        <Table.Cell>{data?.timeNow || 'N/A'}</Table.Cell>

        <Table.Cell className="whitespace-nowrap">
          <button
            className="text-customgreen hover:text-white border-2 border-customgreen hover:bg-hovergreen focus:outline-none focus:ring-customgreen font-medium rounded-full text-sm px-3 py-2 text-center  "
            onClick={(e) => handleCopy(e, data?.campaignID)}
          >
            <LinkOutlinedIcon />
            {t('Get Link')}
          </button>
        </Table.Cell>
      </Table.Row>
    );
  });

  // Export xlsl file
  const formatTime = (time) => {
    return `\t${time}`;
  };

  const handleOnExport = () => {
    const filteredData = compaignList?.map((item, ii) => ({
      [t('S.No')]: ii + 1,
      [t('Campaign Name')]: item.campaignName,
      [t('Date')]: item.date,
      [t('Time')]: formatTime(item.timeNow),
    }));
    downloadCSV(filteredData, 'Campaign List');
  };
const handlePrint = (e) => {
  e.preventDefault();
  
  // Column configuration
  const columns = [
    {
      header: t('sNo'),
      accessor: (row, index) => index + 1
    },
    {
      header: t('Campaign Name'),
      accessor: (row) => isActive ? row?.campaignName || 'N/A' : row?.campaignName || 'N/A'
    },
  
    {
      header: t('Date'),
      accessor: (row) => row?.date || 'N/A'
    },
    {
      header: t('Time'),
      accessor: (row) => row?.timeNow || 'N/A'
    }
  ];
  
  // Call the reusable print function
  printTable({
    data: compaignList || [],
    isRTL: isActive, // isActive true = Arabic = RTL
    t: t,
    title: `${t('Campaign')} ${t('list')}`,
    columns: columns,
    onBeforePrint: () => {
      console.log('Printing started...');
      // toast.info(t('Preparing print preview...'));
    },
    onAfterPrint: () => {
      console.log('Printing completed');
    },
    styles: {
      customCSS: `
        /* Additional custom styles if needed */
        .print-table th {
          font-weight: 600;
        }
        @media print {
          .print-title {
            color: #000 !important;
          }
        }
      `
    }
  });
};
  // const handlePrint = (e) => {
  //   e.preventDefault();

  //   // Create a container for the table
  //   const tableContainer = document.createElement('div');
  //   tableContainer.className = 'tableData my-4';

  //   // Create and add the heading
  //   const heading = document.createElement('h1');
  //   heading.className = 'font-bold text-center my-8 sm:text-2xl text-xl text-customgreen';
  //   heading.innerText = `${t('Goodwill Ambassador Campaign List')}`;
  //   tableContainer.appendChild(heading);

  //   // Create the table
  //   const table = document.createElement('table');
  //   table.style.width = '100%';
  //   table.innerHTML = `
  //   <thead style="background-color: #2f855a; color: white;">
  //     <tr>
  //       <th style="padding: 5px; border: 1px solid #ddd;">#</th>
  //       <th style="padding: 5px; border: 1px solid #ddd;">${t(`Campaign Name`)}</th>
  //       <th style="padding: 5px; border: 1px solid #ddd;">${t(`Date`)}</th>
  //       <th style="padding: 5px; border: 1px solid #ddd;">${t(`Time`)}</th>
  //     </tr>
  //   </thead>
  //   <tbody>
  //     ${compaignList
  //       .map(
  //         (data, index) => `
  //       <tr style="background-color: ${index % 2 === 0 ? '#f9f9f9' : '#fff'}; border: 1px solid #ddd;">
  //         <td style="padding: 5px; border: 1px solid #ddd;">${index + 1}</td>
  //         <td style="padding: 5px; border: 1px solid #ddd;">${data?.campaignName || 'N/A'}</td>
  //         <td style="padding: 5px; border: 1px solid #ddd;">${data?.date}</td>
  //         <td style="padding: 5px; border: 1px solid #ddd;">${data?.timeNow || 'N/A'}</td>
  //       </tr>
  //     `,
  //       )
  //       .join('')}
  //   </tbody>
  // `;

  //   tableContainer.appendChild(table);
  //   document.body.appendChild(tableContainer);

  //   // Add CSS for print styling
  //   const style = document.createElement('style');
  //   style.textContent = `
  //   @media print {
  //    body * {
  //       visibility: hidden;
  //       height: 0;

  //     }
  //     .tableData, .tableData * {
  //       visibility: visible;
  //     }
  //     .tableData {
  //       position: absolute;
  //       left: 0;
  //       top: 0;
  //       width: 100%;
  //       height: auto;
  //       overflow: visible;
  //     }
  //   }
  // `;
  //   document.head.appendChild(style);

  //   // Trigger the print dialog after a small delay to ensure styles are applied
  //   setTimeout(() => {
  //     window.print();

  //     // Clean up by removing the table container and style from the DOM
  //     document.body.removeChild(tableContainer);
  //     document.head.removeChild(style);

  //     // Revert display of other elements after printing
  //     setTimeout(() => {
  //       document.querySelectorAll('body > *').forEach((el) => {
  //         el.style.display = 'block';
  //       });
  //     }, 100); // Adjust delay as needed
  //   }, 500); // Adjust delay as needed

  //   return 'success';
  // };
  return (
    <>
      {isLogin() ? (
        <div className=" pt-12 py-10">
          <Userbanner />

          {serviceCheck.serviceShow ? (
            <>
              {' '}
              <section className="text-gray-600 body-font ">
                <div className="container mx-auto flex px-5  items-center justify-center flex-col">
                  <img
                    className="lg:w-1/3 md:w-3/6 w-5/6 object-cover object-center rounded"
                    alt="hero"
                    src="/assets/not-register.png"
                  />
                  <h1 className="text-center text-customgreen font-semibold text-2xl mt-5">
                    {t(serviceCheck.message)}
                  </h1>
                  {serviceCheck.statusCode === 423 ||
                  serviceCheck.statusCode === 406 ||
                  serviceCheck.statusCode === 426 ? (
                    <></>
                  ) : (
                    <Link to={'/GWARegister'}>
                      <p className="text-center text-blue-500 underline font-semibold ">
                        {t('Click here to register as Good Will Ambassador')}
                      </p>
                    </Link>
                  )}
                </div>
              </section>
            </>
          ) : (
            <div className="  container-fluid">
              <div className="row justify-center">
                <SearchFilters
                  handleSearch={handleSearch}
                  setDateFrom={setDateFrom}
                  setDateTo={setDateTo}
                  dateTo={dateTo}
                  dateFrom={dateFrom}
                  handlePrint={handlePrint}
                  handleOnExport={handleOnExport}
                  heading={'Goodwill Ambassador Campaign List'}
                />
                <div className="col-lg-11 pt-9  ">
                  {isLoading ? (
                    <LoadingAnimation
                      imageStyling={'pb-10 sm:pb-28 md:pb-0 '}
                      styling={'flex items-center pt-10 align-middle justify-center space-x-2'}
                    />
                  ) : (
                    <>
                      {/* Description View Modal */}
                      <MDBModal show={gridModalOpen} onHide={() => setGridModalOpen(false)}>
                        <MDBModalDialog>
                          <MDBModalContent className="bg-green-50">
                            {/* Move the Form component outside the ModalHeader */}
                            <Form>
                              <MDBModalHeader className="text-customgreen font-semibold flex justify-center items-center">
                                <MDBModalTitle>{t('Description')}</MDBModalTitle>
                                {/* <MDBBtn type="button" className="btn-close" color="none" onClick={closeModal}></MDBBtn> */}
                              </MDBModalHeader>
                              <MDBModalBody style={{ minHeight: 200 }} className="container-fluid bd-example-row">
                                {selectedReason}
                              </MDBModalBody>
                              <MDBModalFooter>
                                <button
                                  className="text-white bg-customgreen hover:bg-hovergreen   rounded-full  px-4 py-2 me-2 text-center"
                                  onClick={closeModal}
                                >
                                  {t('close')}
                                </button>
                              </MDBModalFooter>
                            </Form>
                          </MDBModalContent>
                        </MDBModalDialog>
                      </MDBModal>
                      {/* Description View Modal End */}
                      <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
                        <Table className="text-sm  tableData text-left rtl:text-right text-gray-500">
                          <Table.Header className="text-sm font-bold text-white bg-customgreen uppercase  ">
                            <Table.Row>
                              <Table.HeaderCell className="text-white whitespace-nowrap">{t('sNo')}</Table.HeaderCell>
                              <Table.HeaderCell className="text-white whitespace-nowrap">
                                {t('Campaign Name')}
                              </Table.HeaderCell>
                              <Table.HeaderCell className="text-white whitespace-nowrap">
                                {t('Description')}
                              </Table.HeaderCell>
                              <Table.HeaderCell className="text-white whitespace-nowrap">{t('Date')}</Table.HeaderCell>
                              <Table.HeaderCell className="text-white whitespace-nowrap">{t('Time')}</Table.HeaderCell>
                              <Table.HeaderCell className="text-white whitespace-nowrap">
                                {t('Get Link')}
                              </Table.HeaderCell>
                            </Table.Row>
                          </Table.Header>
                          <Table.Body>{displayRecords}</Table.Body>
                        </Table>{' '}
                        {datanotfound && <DataNotFound />}
                      </div>
                      {pageCount > 0 && (
                        <div className="flex flex-row px-12 justify-between">
                          <Menu floated="right" pagination>
                            <Menu.Item>
                              <ReactPaginate
                                previousLabel={t('Previous')}
                                nextLabel={t('Next')}
                                pageCount={pageCount}
                                onPageChange={changePage}
                                containerClassName={'paginationButtons'}
                                previousLinkClassName={'previousButton'}
                                nextLinkClassName={'nextButton'}
                                disabledClassName={'paginationDisabled'}
                                activeClassName={'paginationActive'}
                              />
                            </Menu.Item>
                          </Menu>
                        </div>
                      )}
                    </>
                  )}
                </div>
              </div>{' '}
            </div>
          )}
        </div>
      ) : (
        <>
          <h1>{t('Not Authorized')}</h1>
        </>
      )}
    </>
  );
};

export default CampaignList;
